import { defineStore } from "pinia";

// Тематические слои поверх подложки (меню «Слои»): границы охраняемых
// территорий и покрытие троп маршрутами. Оба выключены по умолчанию;
// выбор - удобство конкретного браузера (localStorage), без бэкенда.
const STORAGE_KEY = "eco_map_overlays";
export type OverlayKey = "protectedAreas" | "routeCoverage";

const load = (): Record<OverlayKey, boolean> => {
  const fallback = { protectedAreas: false, routeCoverage: false };
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return {
      protectedAreas: parsed?.protectedAreas === true,
      routeCoverage: parsed?.routeCoverage === true,
    };
  } catch {
    return fallback;
  }
};

export const useMapOverlaysStore = defineStore("mapOverlays", {
  state: load,
  actions: {
    toggle(key: OverlayKey) {
      this[key] = !this[key];
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ protectedAreas: this.protectedAreas, routeCoverage: this.routeCoverage }));
      } catch {
        /* хранилище недоступно - выбор просто не переживёт перезагрузку */
      }
    },
  },
});
